import {
  container,
  cardTitle,
  title,
  mlAuto,
  mrAuto,
  main,
  whiteColor,
  mainRaised,
  grayColor,
  infoColor,
  dangerColor,
  blackColor,
  eflexTextColor,
  hexToRgb
} from "assets/jss/material-kit-pro-react.js";

import imagesStyle from "assets/jss/material-kit-pro-react/imagesStyles.js";

import tooltipsStyle from "assets/jss/material-kit-pro-react/tooltipsStyle.js";

import customCheckboxRadioSwitch from "assets/jss/material-kit-pro-react/customCheckboxRadioSwitchStyle.js";

import customSelectStyle from "assets/jss/material-kit-pro-react/customSelectStyle.js";

const profilePageStyle = {
  container,
  ...customSelectStyle,
  ...imagesStyle,
  ...tooltipsStyle,
  ...customCheckboxRadioSwitch,
  cardTitleWhite: {
    ...cardTitle,
    color: whiteColor + "  !important"
  },
  cardTitle,
  profile: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: grayColor[0]
  },
  textCenter: {
    textAlign: "center !important"
  },
  name: {
    marginTop: "-80px"
  },

  main: {
    ...main
  },
  mainRaised: {
    ...mainRaised
  },
  title: {
    ...title,
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  follow: {
    position: "absolute",
    top: "0",
    right: "0"
  },
  followIcon: {
    width: "20px",
    height: "20px"
  },
  followButton: {
    marginTop: "-28px !important"
  },
  gridItem: {
    ...mlAuto,
    ...mrAuto
  },
  collections: {
    marginTop: "20px"
  },
  cardBody: {
    display: "flex",
    boxOrient: "vertical",
    boxDirection: "normal",
    flexDirection: "column",
    boxPack: "center",
    justifyContent: "center"
  },
  badge: {
    display: "inline-table",
    margin: "0 auto"
  },
  listUnstyled: {
    paddingLeft: "0",
    listStyle: "none",
    "& > li": {
      padding: "5px 0px",
      fontSize: "1em"
    }
  },
  profileTabs: {
    marginTop: "4.284rem",
    marginBottom: "50px"
  },
  card: {
    textAlign: "left !important"
  },
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right"
  },
  icon: {
    width: "18px",
    height: "18px",
    top: "3px",
    position: "relative"
  },
  parallax: {
    height: "380px",
    backgroundPosition: "top center"
  },
  checkedIcon: {
    width: "20px",
    height: "20px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", 0.84)",
    borderRadius: "3px"
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "9px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px"
  },
  textAreaWithStyle: {
    border: 0,
    borderRadius: 3,
    boxShadow: "0 2px 3px -2px rgba(" + hexToRgb(grayColor[9]) + ",.4)",
    width:"100%",
    color: "black",
    padding: "10px 20px"
  },
  price: {
    fontSize: "18px",
    color: grayColor[22]
  },
  priceNew: {
    fontWeight: "500",
    color: infoColor[0]
  },
  textBlue: {
    fontWeight: "500",
    color: infoColor[0]
  },
  textWarning: {
    fontWeight: "500",
    color: dangerColor[0]
  },
  textBadge: {
    fontSize: "12px",
    fontWeight: "500"
    },
    pullRight: {
      float: "right"
    },
    productPage: {
      backgroundColor: grayColor[2],
      "& $mainRaised": {
        margin: "-40vh 0 0",
        padding: "40px"
      },
      "& .image-gallery-slide img": {
        borderRadius: "3px",
        maxWidth: "300px",
        height: "auto"
      },
      "& .image-gallery-swipe": {
        margin: "30px 0px",
        overflow: "hidden",
        width: "100%",
        height: "auto",
        textAlign: "center"
      },
      "& .image-gallery-thumbnails > .image-gallery-thumbnails-container .image-gallery-thumbnail": {
        "&.active > .image-gallery-thumbnail-inner": {
          opacity: "1",
          borderColor: grayColor[6]
        },
        "& > .image-gallery-thumbnail-inner": {
          width: "80%",
          maxWidth: "85px",
          margin: "0 auto",
          padding: "8px",
          display: "block",
          border: "1px solid transparent",
          background: "transparent",
          borderRadius: "3px",
          opacity: ".8"
        },
        "& > .image-gallery-thumbnail-inner img": {
          borderRadius: "3px",
          width: "100%",
          height: "auto",
          textAlign: "center"
        }
      }
    },
    textBolder:{
      fontWeight: "600",
    },
    textCaramel: {
      fontWeight: "500",
      color: eflexTextColor
    },
};

export default profilePageStyle;
